import React from 'react';
import cx from 'classnames';
import Carousel from '~/components/ui/Carousel';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { UnderlinedText } from '@zola/zola-ui/src/components/UnderlinedText';

// helpers

import { XS_MOBILE_MAX, TABLET_MAX, DESKTOP_MIN } from '~/libs/universal/utils/device';

import shared from '~/styles/landingPageShared.module.less';
import carouselContent from '../../content/cashFundCarouselContent';
import css from './CashFundCarousel.module.less';

const assetPath = `${process.env.ASSET_PATH}/static-preauth/images/CashGiftsLP/carousel`;

const contentToTiles = () =>
  carouselContent.map((tile, i) => {
    return (
      <div className={css.tileContent} key={`c_${i}`}>
        <picture>
          <source media="(max-width: 767px)" srcSet={`${assetPath}/${tile.file}@1x.jpg`} />
          <source srcSet={`${assetPath}/${tile.file}@2x.jpg`} />
          <img src={`${assetPath}/${tile.file}@1x.jpg`} alt={tile.alt} className={css.tileImg} />
        </picture>
        <div className={css.tileTextbox}>
          <p className={css.tileTitle}>Cash Fund</p>
          <p>{tile.desc}</p>
        </div>
      </div>
    );
  });

type FundAnythingProps = {
  ctaLink: string;
  ctaText: string;
};

/* ------------------------------------------------------------ */
const FundAnything: React.FC<FundAnythingProps> = ({ ctaLink, ctaText }) => {
  const tiles = contentToTiles();
  const responsive = {
    desktop: {
      breakpoint: { max: 10000, min: DESKTOP_MIN },
      items: 4,
      slidesToSlide: 4,
    },
    tablet: {
      breakpoint: { max: TABLET_MAX, min: XS_MOBILE_MAX },
      items: 3,
      slidesToSlide: 3,
    },
    mobile: {
      breakpoint: { max: XS_MOBILE_MAX, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  const sectionClass = cx(shared.sectionContainer, css.section, shared.borderBottom);

  return (
    <section className={sectionClass}>
      <h2 className={cx(shared.sectionTitle, css.sectionTitle)}>Fund Anything You Want</h2>
      <div className={css.dek}>
        Weddings are expensive. Couples need cash. We get that more than anyone else. So we make it
        easy to create cash funds for <UnderlinedText color="hardPink">anything.</UnderlinedText>
      </div>
      <div className={css.container}>
        <Carousel
          responsiveOverride={responsive}
          className={css.carousel}
          arrowStyleOverride={css.arrows}
          rightArrowStyleOverride={css.rightArrow}
          leftArrowStyleOverride={css.leftArrow}
        >
          {tiles}
        </Carousel>
      </div>
      <div className={css.ctaContainer}>
        <LinkV2 arrow href={ctaLink}>
          {ctaText}
        </LinkV2>
      </div>
    </section>
  );
};

export default FundAnything;
